import React from 'react';
import { Button } from 'antd';
import s from './s.module.less';
import Star from '../../images/star.svg';

type Props = {
    onUpload?: () => void;
    // copies the provider's own survey link so he/she can invite patients directly
    onInvite?: () => void;
    onDismiss?: () => void;
};

const UploadReviewsBanner = (props: Props) => {
    const { onUpload, onInvite, onDismiss } = props;

    return (
        <div className={s.uploadReviewsBanner}>
            <button type="button" className={s.uploadReviewsBannerClose} aria-label="Dismiss" onClick={onDismiss}>
                ×
            </button>
            <div className={s.uploadReviewsBannerContent}>
                <div className={s.uploadReviewsBannerText}>
                    <h3 className={s.uploadReviewsBannerTitle}>Got reviews? Bring them to Klarity!</h3>
                    <p className={s.uploadReviewsBannerDescription}>
                        Just joined Klarity? You can upload up to{' '}
                        <strong>50 reviews from your existing patients within 30 days</strong>. They&apos;ll show up as
                        anonymous (not verified), but they still give new patients a reason to choose you. Start
                        building your reputation today!
                    </p>
                    <div className={s.uploadReviewsBannerActions}>
                        <Button type="primary" className={s.uploadReviewsBannerBtnUpload} onClick={onUpload}>
                            Upload now
                        </Button>
                        <Button className={s.uploadReviewsBannerBtnDismiss} onClick={onInvite}>
                            Invite patients to leave me reviews
                        </Button>
                    </div>
                </div>
                <div className={s.uploadReviewsBannerImage}>
                    <img src={Star} alt="star" />
                </div>
            </div>
        </div>
    );
};

export default UploadReviewsBanner;
